import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';
import { ToasterService } from 'src/app/Core/services/toaster.service';

@Component({
  selector: 'app-view-dialog',
  templateUrl: './view-dialog.component.html',
  styleUrls: ['./view-dialog.component.css']
})
export class ViewDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ViewDialogComponent>,
    private clipboard: Clipboard, private toaster: ToasterService,
    @Inject(MAT_DIALOG_DATA) public data: {
    serialnumber: string; 
    date: Date;
    type: string;
    count: number; 
}
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }

  onCopyClick(): void {
    if (this.data.type) {
      this.clipboard.copy(this.data.type); 
      this.toaster.openDialogBox("Content copied to clipboard!", false);
    } else {
      alert('No content to copy.');
    }
  }
}
